import React from 'react';
import './DashboardTablePage.css';
import Sidebar from '../../components/sidebar/Sidebar';
import DocumentUploader from "../../components/pageManager/DocumentUploader";

const DocumentUploaderPage = () => {
    return (
        <div className={"dashboard-page"}>
            <div className="dashboard-bggg">
                <div className="dashboard-flex-containerr">
                    <Sidebar />
                    <DocumentUploader />
                </div>
            </div>
        </div>
    );
};

export default DocumentUploaderPage;
